import { render, staticRenderFns } from "./NewChipeSim.vue?vue&type=template&id=2477ea26"
import script from "./NewChipeSim.vue?vue&type=script&lang=js"
export * from "./NewChipeSim.vue?vue&type=script&lang=js"
import style0 from "./NewChipeSim.vue?vue&type=style&index=0&id=2477ea26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports